// components/search-form/component
// форма поиска
/* global DEBUG */

import template from './template.jade'
import style from './style.scss'
import parseUnixTime from 'lib/parseUnixTime'
import datetimepicker from './datetimepicker'
import CurrentInput from 'lib/CurrentInput'

var name = 'search-form'

CurrentInput(jQuery)

export default {
  name: name,
  template: template({
    style: style
  }),
  props: ['placeholder', 'pattern', 'searchform'],

  data: () => ({
    date_at: null,
    date_to: null,
    number: null,
    disabled: false,
  }),

  ready() {
    // привязывваем datetimepicker к input
    datetimepicker(style)

    // привязываем паттерн к input
    var input = document.querySelector('.' + style.input)
    var pattern = new RegExp(this.pattern, 'g')
    $(input).currentInput({ pattern: pattern })
    var now = new Date()
    var date_at = now.setDate(now.getDate() - 30) / 1000
    now = new Date()
    var date_to = now.getTime() / 1000
    this.$set('date_at', parseUnixTime(date_at, 'dateVs'))
    this.$set('date_to', parseUnixTime(date_to, 'dateVs'))
     //console.log('on ready: ', this.$get('date_at'),this.$get('date_to'))
  },

  watch: {
    'date_at + date_to': function() {
      if (this.date_at && this.date_to) {
        var name = this.$parent.$get('name')
/*
      DEBUG && console.log('search-form: ', `dates:${name}`)
*/
          // кидаем event детям родителя
/*     console.log(this.$parent);
     console.log(name);*/
        if (name=== 'zayavki-list') {
            this.$parent.$parent.$broadcast(`dates:${name}`, {
                name: name,
                date_at: (new Date(this.$get('date_at').split('-').reverse().join('-')).getTime()) / 1000,
                date_to: (new Date(this.$get('date_to').split('-').reverse().join('-')).getTime()) / 1000,
            });
            name = 'auto-import-list';
            this.$parent.$parent.$broadcast(`dates:${name}`, {
                name: name,
                date_at: (new Date(this.$get('date_at').split('-').reverse().join('-')).getTime()) / 1000,
                date_to: (new Date(this.$get('date_to').split('-').reverse().join('-')).getTime()) / 1000,
            })
        } else {
        this.$parent.$broadcast(`dates:${name}`, {
          name: name,
          date_at: (new Date(this.$get('date_at').split('-').reverse().join('-')).getTime()) / 1000,
          date_to: (new Date(this.$get('date_to').split('-').reverse().join('-')).getTime()) / 1000,
        })
      }

      }

      this.$set('disabled', true)
      this.$once('fetchData:completed', () => this.$set('disabled', false))
     //  console.log(this.$get('disabled'))
    },

    number: function() {
      // нужно проверять на корректность
    },
  },

  methods: {
    // TODO: проверка на корректность number
    search() {
      if (!this.$get('number')) return;
      var name = this.$parent.$get('name')
      //DEBUG && console.log(`number - search():${name}`)
        // кидаем event детям родителя
      this.$parent.$broadcast(`number:${name}`, {
        name: name,
        number: this.$get('number'),
      })

      //this.$set('number', null)
    },
    searchFast(){
      let cntList,found;
      let number = this.$get('number');
        this.$parent.$children.forEach((item)=>{
            if (item.url === '/api/CntList'){
                cntList = item;
            }
        });
      if (cntList  !== undefined){
          found  = cntList.searchContainerInTable(number);
          //console.log(found);
      }

    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/search-form/component.js
 **/